import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DriverWageAccount from './driver-wage-account.jsx';

export default class DriversWageAccounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      drivers_wage_accounts: props.driversWageAccountsAll || [],
      isLoading: true,
      url: props.url || '/api/v1/drivers/wage-accounts'
    };

    if (this.state.isLoading === true) {
      this.getDriversWageAccounts();
    }
  }

  getDriversWageAccounts() {
    let url = this.state.url;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driversWageAccountsJson) => {
        this.setState({
          drivers_wage_accounts: driversWageAccountsJson,
          isLoading: false,
        })
      });
    });
  }

  render() {
  let DriversWageAccounts = [];
  if (this.state.drivers_wage_accounts &&
    this.state.drivers_wage_accounts.length > 0) {
      this.state.drivers_wage_accounts.forEach(function(i) {
        DriversWageAccounts.push(
          <DriverWageAccount
            key={'drivers-wage-accounts-'+i.id}
            data={i}
          />
       );
    });
  }
  return (<div> {
    this.state.isLoading ?(
      <div className="loading-box">
        <span className="add-loading-text">
          <i className="fa fa-spinner fa-pulse"></i>
        </span>
      </div>
    ) : DriversWageAccounts}
  </div>)
  }
}
if (document.getElementById(
      'react-component-g4-logistics-portal-drivers-wages')) {
    ReactDOM.render(
    <DriversWageAccounts
      url = {"/api/v1/portal/drivers/wage-accounts"}
      message_if_none = 'Wage accounts not found or available for viewing.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-wages'
    )
  );
}
